<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" class="label-gray" label-width="100px" :rules="rules" ref="dialogForm">
      <el-form-item label="状态" prop="status" v-if="dialogData.row">
        <el-select v-model="dialogForm.status">
          <el-option v-for="(item,index) in adminAccountStatus" :key="index" :label="item.msg.replace('已','')" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="真实姓名" prop="name">
        <el-input v-model.trim="dialogForm.name" clearable maxLength="6"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model.trim="dialogForm.mobile" clearable maxLength="11"></el-input>
      </el-form-item>
      <el-form-item label="所属角色" prop="role_id">
        <el-select v-model="dialogForm.role_id">
          <el-option v-for="(item,index) in roles" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty,changeEmpty,checkMobile,checkUsername,checkPwd,checkMailbox,checkRealName,checkIdNumber} from '@utils/validate'
  import {adminAccountStatus} from "@utils/formatList"
  export default {
    name: "AccountOperate",
    props: {dialogData: Object},
    data() {
      return {
        adminAccountStatus,
        dialogForm: {
          name: "",
          mobile: "",
          role_id: "",
          status: "",
        },
        rules: {
          name: [inputEmpty("姓名"),checkRealName()],
          mobile: [inputEmpty("手机号"),checkMobile()],
          role_id: [changeEmpty("所属角色")],
        },
        roles: [],
      }
    },
    async created() {
      await this.getRoles();
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.dialogForm).forEach(key => this.dialogForm[key] = this.showData(key, row, ""));
      } else {
        delete this.dialogForm.status
      }
    },
    methods: {
      confirm() {
        let row = this.dialogData.row;
        row ? this.revise(row) : this.add();
      },
      add() {
        this.$refs["dialogForm"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.dialogForm};
            let res = await this.$Http.addManager(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
      revise(row) {
        let nv = {};
        for(let [key, val] of Object.entries(this.dialogForm)) {
          if (val !== this.showData(key, row, "")) {
            nv[key] = val;
          }
        }
        if (Object.keys(nv).length) {
          this.$refs["dialogForm"].validate(isOk => {
            if (isOk) {
              this.openConfirm("修改该子账号", async () => {
                nv.optionId = row.id;
                let res = await this.$Http.reviseManager(nv);
                if (res) {
                  this.msgSuccess("修改成功");
                  this.$emit("table-reload");
                  this.dialogData.visible = false;
                }
              });
            }
          });
        } else {
          this.msgInfo("您尚未做任何修改")
        }
      },
      async getRoles() {
        let res = await this.$Http.getRoleList();
        if (res?.data) {
          this.roles = this.getArray(res.data.list);
        }
      },
    }
  }
</script>

<style scoped>

</style>
